module.exports = __webpack_public_path__ + "static/md-de1a8f4c753450a014c76f5ff09d73a7.svg";